export enum ProgramStatus {
  INIT = 'INIT',
  UPDATED = 'UPDATED',
  FINISHED = 'FINISHED',
  CANCELED = 'CANCELED',
  PAUSED = 'PAUSED',
  NOT_EXECUTED = 'NOT_EXECUTED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}
